import "./standard-loader.scss";
import m from "mithril";

export default () => {
	return {
		view: () => {
			return m(".standard-loader");
		},
	};
};
